import { styled } from "../stitches";

const Image = styled('img', {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "none",
    objectFit: "cover",
    textIndent: "-9999px",
})

export default Image;